<template>
  <div class="wrapper" :class="{'wrapper-no-border': summaryPage}">
    <div class="container" :class="{'container-no-padding': summaryPage}">
      <BaseBtn v-if="!isLoading" @click="openModal" :class="{'modal-btn-icon': summaryPage}" class="modal-btn">
        <div>{{ text }}</div>
        <div :class="{'see-all-icon': !summaryPage}" class="see-all">See all</div>
      </BaseBtn>
      <SkeletonWrapper :isLoading="isLoading">
        <div class="tags">
          <Tag
            v-for="filter in slicedFilters"
            :tag="{...filter, isActive: filter.value}"
            :key="filter.id"
            @click="toggleTag(filter)"
            :class="{'tag-withcheckmark': filter.value}"
            :darkSelection="true"
          />
          <!--
          <BaseBtn v-if="!isLoading && !summaryPage" @click="openModal" class="more-btn"
            >{{ availableFilters.length - 10 }} More</BaseBtn
          >
          -->
        </div>
      </SkeletonWrapper>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VueCompositionAPI, {computed} from '@vue/composition-api';
import BaseBtn from '@common/button/button.vue';
import Tag from '@common/filter-tag/tag.vue';
import SkeletonWrapper from '@common/skeleton-wrapper.vue';

Vue.use(VueCompositionAPI);

export default {
  setup(props, {emit}) {
    function toggleTag(e) {
      const selectedFilters = props.filters
        .filter((f) => f.value)
        .map((filter) => {
          return {...filter, value: true};
        });
      emit('tags-changed', [...selectedFilters, {...e, value: !e.value}]);
    }

    function openModal() {
      emit('openModal', {type: props.modal === 'FLIGHT' ? props.modal : 'INTERESTS'}, props.modal);
    }

    const availableFilters = computed(() => {
      return props.filters ? props.filters.filter((x) => x.domain === props.domain && x.name) : [];
    });

    const slicedFilters = computed(() => {
      return availableFilters.value.sort((a, b) => b.value - a.value).slice(0, 10);
    });

    const isLoading = computed(() => {
      return !slicedFilters || availableFilters.value.length < 5;
    });

    return {toggleTag, availableFilters, slicedFilters, openModal, isLoading};
  },

  name: 'FilterTagsRow',
  props: ['filters', 'domain', 'modal', 'text', 'click', 'summaryPage'],
  components: {
    Tag,
    BaseBtn,
    SkeletonWrapper,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: hidden;
  display: flex;
  align-items: baseline;
  border-top: 1px solid #f1f1f1;
}
.container {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  padding-top: 10px;
}

.wrapper-no-border {
  border: none;
}

.container-no-padding {
  padding-top: 0;
}

.see-all {
  padding-right: 10px;
  position: relative;
  color: var(--font-color-light);
  font-size: 12px;
  font-weight: normal;
}

.see-all-icon {
  position: relative;
}
.see-all-icon::after {
  content: '';
  top: -2px;
  right: -2px;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url(../icon-filter-downarrow.svg);
  opacity: 0.5;
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
}

.modal-btn-icon {
  position: relative;
}

.modal-btn-icon::after {
  content: '';
  top: 6px;
  right: 35px;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url(../icon-filter-downarrow.svg);
  opacity: 0.5;
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
}

.tags::-webkit-scrollbar {
  display: none;
}
.modal-btn {
  position: absolute;
  padding: 0 8px 0 0;
  text-align: left;
  color: var(--font-color-dark);
  font-weight: bold;
  font-size: 14px;
  border: none;
  background-color: transparent;
  border-radius: 0;
  border-right: 1px solid #f1f1f1;
  min-width: 95px;
}

.more-btn {
  position: relative;
  padding: 10px 10px 0;
  color: var(--font-color-dark);
  border: none;
  background-color: transparent;
  border-radius: 0;
  color: var(--font-color-light);
  font-size: 12px;
  font-weight: normal;
  min-width: 80px;
  height: 35px;
}

.more-btn::after {
  content: '';
  top: 8px;
  right: -2px;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url(../icon-filter-downarrow.svg);
  opacity: 0.5;
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
  transform: rotate(-90deg);
}

.tags {
  margin-left: 100px;
  display: flex;
  overflow: auto;
  width: 100%;
}
</style>
